<template>
  <div v-if="ad">
    <div class="ad-rejected-summary">
      <!-- start under review case -->
      <div class="flex items-center justify-between" v-if="ad.acceptance_status === $constants.AD_ACCEPTANCE_STATUSES.UNDER_REVIEW">
        <div class="space-x-5">
          <img class="inline-block align-middle" width="24" height="24" src="@/assets/images/under-preview.svg" alt="under preview"/>
          <span>Under review ad.</span>
        </div>

        <div v-if="isViewRecommendationEnabled"
          class="view-reccomendition-parent md:float-right whitespace-no-wrap">
          <button
            @click="showRecommenitionPopup = true"
          >
            {{$t("create_campaign.step5.ad_status.view_recommendations_btn")}}
          </button>
        </div>
      </div>
      <!-- end under review case -->

      <!-- start accepted case -->
      <div class="flex items-center space-x-5" v-if="ad.acceptance_status === $constants.AD_ACCEPTANCE_STATUSES.ACCEPTED">
        <img class="inline-block align-middle" width="24" height="24" src="@/assets/images/calibration.svg" alt="celebarate"/>
        <span>Accepted Ad.</span>
      </div>
      <!-- end accepted case -->

      <!-- start hold case -->
      <div class="items-center space-x-5 ad-rejected-summary" v-if="ad.acceptance_status === $constants.AD_ACCEPTANCE_STATUSES.ON_HOLD && feedback">
        <div>
          <div>
            <vs-icon icon-pack="speakol" icon="speakol-unverify" color="#db2828"></vs-icon>
            <span>On hold ad.</span>
          </div>

          <div class="reasons">
            <div>
              <p>{{$t("create_campaign.step5.ad_status.hold_desc")}}</p>
              <ul>
                <li class="ml-2" v-for="reviewReason in reviewReasons" :key="reviewReason.id">
                  {{reviewReason.reason}}
                </li>
              </ul>
            </div>

            <div v-if="feedback && feedback.summary">
              <div class="title mt-4">{{$t("create_campaign.step5.ad_status.extra_comments")}}</div>
              <div class="rejection-content-element">{{feedback.summary}}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- end hold case -->

      <!-- start rejected case -->
      <div class="rejected-ad md:flex justify-between ad-rejected-summary space-x-5" v-if="ad.acceptance_status === $constants.AD_ACCEPTANCE_STATUSES.REJECTED">
        <div>
          <div class="flex">
            <img alt="ad-has-error" src="@/assets/images/ads-recommendition.svg"/>
            <!-- <vs-icon icon-pack="speakol" icon="speakol-cancel" color="#ec0000"></vs-icon> -->
            <span>{{$t("create_campaign.step5.ad_status.rejection_title")}}</span>
          </div>

          <div class="reasons">
            <div>
              <p v-if="reviewReasons.length == 1">{{$t("create_campaign.step5.ad_status.rejection_desc_one_reason")}}</p>
              <p v-else>{{$t("create_campaign.step5.ad_status.rejection_desc")}}</p>
              <ul>
                <li class="ml-2" v-for="reviewReason in reviewReasons" :key="reviewReason.id">
                  {{reviewReason.reason}}
                </li>
              </ul>
            </div>

            <div v-if="feedback && feedback.summary">
              <div class="extra-comments-title title">{{$t("create_campaign.step5.ad_status.extra_comments")}}</div>
              <div class="rejection-content-element">{{feedback.summary}}</div>
            </div>
          </div>
        </div>

        <div class="view-reccomendition-parent md:float-right whitespace-no-wrap">
          <vx-tooltip v-if="!isViewRecommendationEnabled" text="No recommendations" position="top">
            <button
              @click="showRecommenitionPopup = true"
              :disabled="!isViewRecommendationEnabled"
              :class="{'text-speakol-disabled-color cursor-not-allowed': !isViewRecommendationEnabled}"
            >
              {{$t("create_campaign.step5.ad_status.view_recommendations_btn")}}
            </button>
          </vx-tooltip>

          <button
              v-else
              @click="showRecommenitionPopup = true , viewRecommendationsEvent()"
              :disabled="!isViewRecommendationEnabled"
              :class="{'text-speakol-disabled-color cursor-not-allowed': !isViewRecommendationEnabled}"
            >
            {{$t("create_campaign.step5.ad_status.view_recommendations_btn")}}
          </button>
        </div>
      </div>
      <!-- end rejected case -->
    </div>

    <!-- recommenition pop up -->
    <vs-popup :active.sync="showRecommenitionPopup">
      <div class="popup-header">
        <h3>{{$t("create_campaign.step5.ad_status.adv_popups.rejection.title")}}</h3>
        <p>{{$t("create_campaign.step5.ad_status.adv_popups.rejection.description")}}</p>
      </div>

      <div class="pop-up-options">
        <div v-if="titles.length > 0" class="recommended-titles">
          <h4>{{$t("create_campaign.step5.ad_status.adv_popups.rejection.titles_header")}}</h4>
          <p>{{$t("create_campaign.step5.ad_status.adv_popups.rejection.titles_desc")}}</p>

          <vs-radio
            @input="recommendationsPopupSelectTitleEvent()"
            class="flex"
            v-for="title in titles"
            :key="title.id "
            :vs-value="title.id"
            v-model="form.title"
          >
            {{title.value}}
          </vs-radio>
        </div>

        <div v-if="images.length > 0" class="recommended-images">
          <h4>{{$t("create_campaign.step5.ad_status.adv_popups.rejection.images_header")}}</h4>
          <p>{{$t("create_campaign.step5.ad_status.adv_popups.rejection.images_desc")}}</p>

          <div class="images-grid grid gap-8 md:grid-cols-3 grid-col-1">
            <vs-radio
            @input="recommendationsPopupSelectImgEvent()"
            v-for="image in images"
            :key="image.id"
            :vs-value="image.id"
            v-model="form.image">
            <img :src="image.value" alt="empty state">
          </vs-radio>
          </div>
        </div>
      </div>

      <h3 class="reasons-err" v-if="errors.any()">{{errors.first('image') || errors.first('title')}}</h3>

      <div class="popup-actions">
        <button
          @click="showRecommenitionPopup = false , cancelRecommenditionPopupEvent()"
          class="cancel-pop-up">
          {{$t("create_campaign.step5.ad_status.adv_popups.rejection.cancel_btn")}}
        </button>

        <button
          class="save-update-button"
          @click="saveSelectedOptionns"
          :disabled="isSubmitBtnDisabled"
          :class="[isSubmitBtnDisabled ? 'disabled-submit-btn': 'enabled-submit-btn']">
          {{$t("create_campaign.step5.ad_status.adv_popups.rejection.save_btn")}}
        </button>
      </div>
    </vs-popup>
    <!-- recommenition pop up -->
  </div>
</template>

<script>

import { get } from 'lodash'

export default {
  props: ['ad'],
  data () {
    return {
      showRecommenitionPopup: false,
      feedback: null,
      titles: [],
      images: [],
      form: this.getFormDefaults()
    }
  },

  async created () {
    this.errors.clear()

    await this.fillForm()
  },

  watch: {
    async showRecommenitionPopup () {
      await this.fillForm()
    }
  },

  computed: {
    isSubmitBtnDisabled () {
      return !this.form.image && !this.form.title
    },

    isViewRecommendationEnabled () {
      if (this.feedback && this.feedback.recommendations) {
        const pendingCount = this.feedback.recommendations.filter(rec => rec.status === this.$constants.RECOMMENDATION_ITEM_STATUS.PENDING).length

        return pendingCount > 0
      }

      return false
    },

    reviewReasons () {
      return get(this, 'feedback.review_reasons', [])
    }
  },

  methods: {
    viewRecommendationsEvent () {
      this.$gtag.event('view-recommendations-button')
    },

    cancelRecommenditionPopupEvent () {
      this.$gtag.event('recommendations-popup-cancel-button')
    },

    recommendationsPopupSelectTitleEvent () {
      this.$gtag.event('recommendations-popup-select-title')
    },

    recommendationsPopupSelectImgEvent () {
      this.$gtag.event('recommendations-popup-select-image')
    },

    getFormDefaults () {
      return {
        title: null,
        image: null
      }
    },

    async getAdLatestFeedback () {
      try {
        const response = await window.axios.get(`/feedbacks/ads/${this.ad.id}`, {
          params: {
            type: [
              this.$constants.AD_ACCEPTANCE_STATUSES.REJECTED,
              this.$constants.AD_ACCEPTANCE_STATUSES.UNDER_REVIEW
            ].includes(this.ad.acceptance_status) ? this.$constants.FEEDBACK_TYPES.REJECT : this.$constants.FEEDBACK_TYPES.HOLD
          }
        })

        return response.data.payload ? response.data.payload.feedback : null
      } catch (error) {
        this.$setLaravelValidationErrorsFromResponse(error.response.data)
      }
    },

    async saveSelectedOptionns () {
      this.errors.clear()
      this.$gtag.event('recommendations-popup-save-button')
      try {
        const response = await window.axios.post(`/feedbacks/ads/${this.ad.id}/accept-recommendation`, this.form)

        this.feedback = response.data.payload.feedback

        this.showRecommenitionPopup = false

        this.$emit('accept-recommendation', response.data.payload)
      } catch (error) {
        this.$setLaravelValidationErrorsFromResponse(error.response.data)
      }
    },

    getRecommendationItemsOfSubject (subject) {
      if (this.feedback && this.feedback.recommendations) {
        const recommendationOfSubject = this.feedback.recommendations.find(el => el.subject === subject)

        return recommendationOfSubject ? recommendationOfSubject.recommendation_items : []
      }

      return []
    },

    async fillForm () {
      this.feedback = await this.getAdLatestFeedback()

      this.titles = await this.getRecommendationItemsOfSubject('title')

      this.images = await this.getRecommendationItemsOfSubject('image')

      const selectedTitle = this.titles.find(el => el.status === this.$constants.RECOMMENDATION_ITEM_STATUS.APPLIED)

      const selectedImage = this.images.find(el => el.status === this.$constants.RECOMMENDATION_ITEM_STATUS.APPLIED)

      this.form = {
        title: selectedTitle ? selectedTitle.id : null,
        image: selectedImage ? selectedImage.id : null
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.ad-rejected-summary {
  .reasons-err {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #db2828;
    margin-top: 15px;
  }

  span,
  .title {
    color: #323232;
    font-weight: 500;
    font-size: 14px;
  }

  i {
    font-size: 22px !important;
    font-weight: bolder;
    position: relative;
    top: 4px;
    margin-right: 16px;
  }

  button {
    font-weight: 500;
    font-size: 14px;
    color: #0092d7;
    background: transparent;
    border: none;
    outline: none;
    cursor: pointer;
    position: relative;
    top: 6px;
    font-family: "Poppins", sans-serif;
  }

  .rejection-content-element {
    font-size: 14px;
    color: #797a7b;
    font-weight: 400;
    margin-top: 8px;
  }

  .reasons {
    @extend .rejection-content-element;

    margin-left: 39px;

    ul {
      list-style: disc;
      margin-left: 14px;
    }

    font-weight: 400;
  }
}

.extra-comments-title {
  margin-top: 20px;
}

.rejected-ad {
  img {
    width: 22px;
    height: 22px;
    position: relative;
    top: 0;
    margin-right: 16px;
  }
}

/deep/ .vs-popup {
  width: 580px;
}

.popup-header {
  h3 {
    color: #2c2c2c;
    font-weight: 500;
    font-size: 24px;
    margin-bottom: 8px;
  }

  p {
    font-weight: 300;
    font-size: 14px;
    color: #797a7b;
    margin-bottom: 30px;
  }
}

.pop-up-options {
  /deep/ .vs-radio--label {
    margin-bottom: 16px;
    line-height: 21px;
    // margin-left: 9px;
  }

  .recommended-titles {
    font-weight: 300;
    font-size: 14px;
    color: #323232;

    /deep/ .con-vs-radio {
      align-items: start;
    }

    /deep/ .vs-radio--borde {
      top: 2px !important;
    }

    h3 {
      font-size: 18px;
      color: #323232;
      font-weight: 500;
    }

    p {
      font-weight: 300;
      font-size: 14px;
      color: #797a7b;
      margin-bottom: 26px;
      margin-top: 7px;
    }
  }

  .recommended-images {
    h4 {
      font-weight: 500;
      font-size: 18px;
      color: #2c2c2c;
      margin-bottom: 7px;
      margin-top: 14px;
    }

    p {
      font-weight: 300;
      font-size: 14px;
      color: #797a7b;
      margin-bottom: 24px;
    }

    img {
      width: 100%;
      border-radius: 4px;
    }

    /deep/ .con-vs-radio {
      // margin-right: 32px;
      align-items: start;
    }

    /deep/ .con-vs-radio:last-child {
      margin-right: 0;
    }
  }
}

.popup-actions {
  text-align: right;
  margin-top: 32px;

  .cancel-pop-up {
    margin-right: 16px;
    color: #0092d7;
    height: 39px;
    width: 112px;
    background: transparent;
    border-radius: 4px;
    font-weight: normal;
    font-size: 14px;
    border: 1px solid #0092d7;
    outline: none;
    box-shadow: none;
    cursor: pointer;
    // margin-bottom: 30px;
  }

  .submit-btn {
    height: 40px;
    width: 125px;
    border-radius: 4px;
    color: white;
    font-weight: normal;
    font-size: 14px;
    outline: none;
    box-shadow: none;
    border: none;
  }

  .enabled-submit-btn {
    @extend .submit-btn;

    cursor: pointer;
    background: #0092d7;
  }

  .disabled-submit-btn {
    @extend .submit-btn;

    cursor: not-allowed;
    background: #c2c2c2;
  }
}

/deep/ .vs-radio--circle,
/deep/ .vs-radio--borde {
  width: 15px;
  height: 15px;
}

/deep/ .vs-radio--circle {
  box-shadow: none !important;
}

.images-grid {
  /deep/ .vs-radio--label {
    margin-bottom: 0 !important;
  }
  // justify-items: center;
}

@media (max-width: 768px) {
  .view-reccomendition-parent {
    margin-left: 35px !important;
    margin-top: 16px;
  }
}
</style>
